// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__m3ZiA","sidebarOverlay":"Sidebar_sidebarOverlay__XvEGZ","buttons":"Sidebar_buttons__apjqd"};